import { DialogSelect } from "./DialogSelect";
export default DialogSelect;
